const NAME_REGEX = /^[a-zA-Z0-9]+$/;
const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
const PHONE_REGEX = /^\d{10}$/;

export const validateName = (value: string) => NAME_REGEX.test(value) ? "" : "Name is invalid";

export const validateEmail = (value: string) => !(EMAIL_REGEX.test(value) === false && value !== "")

export const validatePhone = (value: string) => PHONE_REGEX.test(value) && value.length === 9 ? "" : "Phone is invalid";

